import { render } from "./SeriesItem.vue?vue&type=template&id=d12cbbe4"
import script from "./SeriesItem.vue?vue&type=script&lang=js"
export * from "./SeriesItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__